/**
 * @generated SignedSource<<291076e0a4ccd7e3608cc385bf8b99d9>>
 * @relayHash 2d211eb85e0b1bb12867127403ed141b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f437601a6f2a8054512ed84beb0000c8b748083d981b068b40adda9d78e68f0

import type { ConcreteRequest } from 'relay-runtime';
export type JiraAgentSessionPreExecutionStep = "AGENT_READINESS" | "PLANNING" | "%future added value";
export type JiraStartAiAgentSessionInput = {
  agentId: string;
  clientMutationId: string;
  cloudId: string;
  issueId: string;
  preExecutionStep?: JiraAgentSessionPreExecutionStep | null;
  prompt?: string | null;
};
export type useInvokeAgentMutation$variables = {
  input: JiraStartAiAgentSessionInput;
};
export type useInvokeAgentMutation$data = {
  readonly jira_startAiAgentSession: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null;
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type useInvokeAgentMutation = {
  response: useInvokeAgentMutation$data;
  variables: useInvokeAgentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useInvokeAgentMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraStartAiAgentSessionPayload",
        "kind": "LinkedField",
        "name": "jira_startAiAgentSession",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useInvokeAgentMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraStartAiAgentSessionPayload",
        "kind": "LinkedField",
        "name": "jira_startAiAgentSession",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "2f437601a6f2a8054512ed84beb0000c8b748083d981b068b40adda9d78e68f0",
    "metadata": {},
    "name": "useInvokeAgentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "903b5a44ea93397968c19407067dc5f9";

export default node;
